<template>
  <div class="p2_modal_header">
    <div>
    </div>
    <div class="p2_title_box">
       <span class="p2_arrow_icon" @click.prevent="closeSelf"></span>
       <span v-for="(selectedModal,index) in C_titleParts" :key="index">
          <span v-if="separatorNeededCheck(index)" class="p2_modal_title_separator">&nbsp;></span>
          <span @click="closeChildModals(selectedModal)" class="p2_modal_title_text">{{selectedModal}}</span>
       </span>
    </div>
    <div class="p2_exit_box">
      <span class="p2_modal_popout_button" v-if="showPopoutButton==true" @click.prevent="popOutSelf"></span>
      <span class="p2_exit_icon" @click.prevent="closeSelf"></span>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "p2ModalHeader",
  props: ["title", "showPopoutButton"],
  methods: {
    closeSelf: function() {
      this.$emit("event-close-modal");
    },
    popOutSelf: function() {
      this.$emit("event-popout-modal");
    },
    closeChildModals(selectedModal) {
      this.$emit("event-close-child-modals", selectedModal);
    },
    separatorNeededCheck(index) {
      if(index <1) {return(false);}
      if(index < (this.C_titleParts.length)) { return(true);}
      return(false);
    }
  },
  computed: {
    C_titleParts() {
      return this.title.split(">");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/p2Dashboard/p2ModalHeader.vue